export const iconFontAwesomeHouseholdRug = (
	<i className="fa-solid fa-rug"></i>
);
